import { Component, OnDestroy, OnInit } from '@angular/core';
import { CounterSharedService } from './counterSevice';

@Component({
  selector: 'conter-value',
  host: {
    class: 'axis-input-group-addon'
  },
  template: `
    <span *ngIf="this.counterInstance.countDown || this.counterInstance.countDown===0" 
    class='axis-countdown'>{{this.counterInstance.counterValue}}</span>
    <span *ngIf="this.counterInstance.counter || this.counterInstance.counter===0" 
    class='axis-countdown'>{{this.counterInstance.counterValue}} of {{this.counterInstance.max}}</span>
    `
})
export class CounterValueComponent implements OnInit, OnDestroy {
  public uniqueKey: number;
  public counterInstance: any;

  constructor(public counterSharedService: CounterSharedService) {}

  ngOnInit() {
    this.counterInstance = this.counterSharedService.getInstance(
      this.uniqueKey
    );
  }
  ngOnDestroy() {
    this.counterInstance = null;
    this.counterSharedService.destroyInstance(this.uniqueKey);
  }
}
